<template>
    <li :class="[obj.theme? 'is-'+ obj.theme: '']" @click.stop>
        <div
            class="div"
            :class="[obj.action? 'is-hover': '']"
            @click.stop="sendClick"
        >
            <ul class="func">
                <li v-if="obj.remove !== false" class="remove"><a title="關閉" @click.stop="sendRemove"></a></li>
            </ul>
            <div class="essay">
                <div class="caption">{{ obj.caption }}</div>
                <div class="label">
                    <span
                        class="process"
                        :style="{
                            width: obj.process +'%'
                        }"
                    ></span>
                    <span class="status">{{ obj.text }}</span>
                </div>
                <div class="size">{{ obj.size / 1000 }} kb</div>
            </div>
        </div>
    </li>
</template>

<script>
    export default {
        props: {
            obj: {
                type: Object,
                require: true
            }
        },
        methods: {
            sendClick: function(){
                let $obj = this.obj,
                    _action = $obj.action;

                if( _action ) {
                    this.$emit('sendEvent', 'clickItem', this.obj);
                }
            },
            sendRemove: function(){
                this.$emit('sendEvent', 'removeItem', this.obj);
            },
        }
    }
</script>

<style scoped lang="scss">

    li {
        
    }
</style>
